import type { HeelSizeValue } from '../types/taste-config'

/**
 * Маппинг размеров каблуков на пути к статическим изображениям
 * Изображения хранятся в public/img/
 */
export const HEEL_SIZE_IMAGES: Record<HeelSizeValue, string> = {
  'up-to-4cm': '/img/low-heel.svg',
  '5-7cm': '/img/mid-heel.svg',
  '8cm-plus': '/img/high-heel.svg'
}

/**
 * Получить путь к изображению для размера каблука
 */
export function getHeelSizeImage(heelSize: HeelSizeValue): string {
  return HEEL_SIZE_IMAGES[heelSize]
}

